window.addEventListener('b4bVariantsDisplayed', function(e) {
    const variantsArray = Object.values(e.detail.variants);

    // Count repeated handles
    const counts = variantsArray.reduce((acc, item) => {
        acc[item.handle] = (acc[item.handle] || 0) + 1;
        return acc;
    }, {});

    const perRowView = document.querySelector('#product-grid');
    if(perRowView.classList.contains('grid--4-col-desktop'))
        perRowView.classList.remove('grid--4-col-desktop');
    //console.log("Ayaz is here: ",perRowView.classList);
    const variantsItems = document.querySelectorAll('#product-grid .grid__item');
    variantsItems.forEach(item => {
        const handle = item.getAttribute('data-handle');
        item.classList.add('b4b-activated');
        let isAvailable = true;
        if(item.getAttribute('data-unavailable') === 'true')
            isAvailable = false;

        // hide all variant fieldsets initially
        item.querySelectorAll('pcard-variant fieldset').forEach(fs => {
            if (fs && fs.classList) {
                fs.classList.add('d-none');
            }
        });
        const atcButton = item.querySelector('product-form button');
        if(isAvailable === false && atcButton) {
            atcButton.disabled = true;
            atcButton.querySelector('.js-main-button-span').textContent = 'Sold Out';
        }

        // If handle is repeated, hide all fieldsets
        /*if (counts[handle] > 1) {
            item.querySelectorAll('pcard-variant fieldset').forEach(fs => {
                if (fs && fs.classList) {
                    fs.classList.add('d-none');
                }
            });
        }*/
    });


});